/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.AiFeedbackRpc
 */

export const sendAiFeedbackRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.AiFeedbackRpc',
  rpcName: 'sendAiFeedback',
  auth: 'app',
  fingerprint: 'SQP9_7tA4COnIYP7irlgFDCnF6yLGW3Q',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};